import { EMAIL_REGEX, URL_REGEX } from '@constants/common';
import { PHONE_REGEX } from '@constants/schema';
import * as Yup from 'yup';

const CompanyCreationSchema = Yup.object({
    name: Yup.string().trim().required('Required'),
    vat_number: Yup.string().trim(),
    chamber_of_commerce_number: Yup.string().trim().max(8, 'Maximum of 8 characters').required('Required'),
    services: Yup.array()
        .of(Yup.object().shape({ id: Yup.number() }))
        .min(1, 'Required')
        .required('Required'),
    markets_ids: Yup.array().of(Yup.number()).min(1, 'Required').required('Required'),
    address: Yup.string().trim().required('Required'),
    city: Yup.string().trim().required('Required'),
    country_code: Yup.string().trim().required('Required'),
    province: Yup.string().trim(),
    phone_number: Yup.string().trim().matches(PHONE_REGEX, 'Phone number is not valid'),
    fax_number: Yup.string().trim().matches(PHONE_REGEX, 'Fax number is not valid'),
    commercial_email: Yup.string()
        .trim()
        .matches(EMAIL_REGEX, 'Invalid email')
        .email('Invalid email')
        .required('Required'),
    support_emails: Yup.string()
        .trim()
        .matches(EMAIL_REGEX, 'Invalid email')
        .email('Invalid email')
        .required('Required'),
    website: Yup.string().trim().matches(URL_REGEX, 'Invalid URL'),
    sales_manager_id: Yup.string().trim(),
    owner_id: Yup.number().when('isAdmin', ([isAdmin], schema) => (isAdmin ? schema.required('Required') : schema)),
    description: Yup.string(),
});

export { CompanyCreationSchema };
